export default __webpack_public_path__ + "static/media/button-menu-hover.ed26ce96.svg";